// extracted by mini-css-extract-plugin
export default {"header":"ReportsHeader_header__x5XOT","dashboardTop":"ReportsHeader_dashboardTop__CcT-6"};